import { isNil } from 'lodash';
import { treeType, treeNodeType, treeNodeSubType } from '@/constants/tree';
import { convertValuByUnit, convertValueByUnitData } from '@/utils/number';

export default {
  computed: {
    selectedTreeType() {
      return this.$store.state.router.treeType;
    },
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
    analysisDateParams() {
      return this.$store.getters.analysisDateParams;
    },
    eventlevelInfo() {
      return this.$store.getters.eventlevelInfo;
    },
    eventlevelList() {
      return this.$store.getters.eventlevelList;
    },
  },
  methods: {
    convertValuByUnit,
    convertValueByUnitData,
    setEventHistStatsParams(params) {
      const selectedTreeType = this.selectedTreeType;
      const selectedNode = this.selectedNode;
      if (selectedTreeType === treeType.PHYSICAL) {
        if (selectedNode.type === treeNodeType.GROUP) {
          params.managetypeId = this.selectedNode.managetypeId;
          params.objtypeId = this.selectedNode.objtypeId;
          // nms일 경우
          params.objCompanyId = this.selectedNode.objCompanyId;
          // vms일 경우
          params.hypervisorType = this.selectedNode.hypervisorType;
          params.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
          params.objId = this.selectedNode.objId;
          params.subType = this.selectedNode.subType;
        } else if (selectedNode.type === treeNodeType.OBJ) {
          params.objId = this.selectedNode.obj.objId;
        }
      } else if (selectedNode.type === treeNodeType.GROUP) {
        if (selectedNode.subType === treeNodeSubType.VIRTUAL) {
          params.objId = this.selectedNode.objId;
          params.objtypeId = this.selectedNode.obj.objtypeId;
          params.subType = this.selectedNode.subType;
        } else {
          params.managegroupIds = this.selectedNode.childManagegroupIds;
        }
      } else if (selectedNode.type === treeNodeType.OBJ) {
        params.objId = this.selectedNode.obj.objId;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/event/event-hist-stats.js